"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("../../styles/Toast.scss");
const types_1 = require("../../types");
const react_1 = require("react");
const ProgressBar_1 = tslib_1.__importDefault(require("./ProgressBar"));
const Toast = (props) => {
    const { toast, noAutoDelete, deleteToast } = props;
    const [isPaused, setIsPaused] = (0, react_1.useState)({ paused: false, timeLeft: 5 });
    const timeRef = (0, react_1.useRef)(5);
    const intervalRef = (0, react_1.useRef)(null);
    const callbackForInterval = () => {
        timeRef.current = timeRef.current - 0.5;
        if (timeRef.current <= 0 && !isPaused.paused) {
            deleteToast(toast.id);
            clearInterval(intervalRef.current);
        }
    };
    (0, react_1.useEffect)(() => {
        intervalRef.current = setInterval(callbackForInterval, 500);
    }, [isPaused]);
    const handleMouseEnter = () => {
        setIsPaused({ paused: true, timeLeft: timeRef.current });
        clearInterval(intervalRef.current);
    };
    const handleMouseLeave = () => {
        clearInterval(intervalRef.current);
        setIsPaused(prevState => {
            return { ...prevState,
                paused: false
            };
        });
        timeRef.current = isPaused.timeLeft;
    };
    let toastVisual = {
        backgroundColor: '',
        iconClass: ''
    };
    switch (toast.type) {
        case types_1.ToastType.DANGER:
            toastVisual = {
                backgroundColor: '#d9534f',
                iconClass: 'exclamation'
            };
            break;
        case types_1.ToastType.SUCCESS:
            toastVisual = {
                backgroundColor: '#5cb85c',
                iconClass: 'check'
            };
            break;
        case types_1.ToastType.WARNING:
            toastVisual = {
                backgroundColor: '#f0ad4e',
                iconClass: 'exclamation'
            };
            break;
        case types_1.ToastType.INFO:
            toastVisual = {
                backgroundColor: '#4556fa',
                iconClass: 'info'
            };
            break;
        default:
            toastVisual = {
                backgroundColor: '#5cb85c',
                iconClass: 'check'
            };
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'notification toasted top-right pt-5 ', style: { backgroundColor: toastVisual.backgroundColor }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [(0, jsx_runtime_1.jsx)("button", { onClick: () => props.deleteToast(toast.id), children: (0, jsx_runtime_1.jsx)("i", { className: 'fas fa-times text-white' }) }), (0, jsx_runtime_1.jsx)("div", { className: 'notification-icon', children: (0, jsx_runtime_1.jsx)("i", { className: `fas fa-${toastVisual.iconClass}-circle text-white` }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("p", { className: 'notification-message', children: toast.message }) }), !noAutoDelete
                && !isPaused.paused
                ? (0, jsx_runtime_1.jsx)(ProgressBar_1.default, { timeLeft: timeRef.current, isPaused: isPaused.paused })
                : null] }));
};
exports.default = Toast;
